import { render, staticRenderFns } from "./AlterarPedidoDeCompraModal.vue?vue&type=template&id=45a84ac0&scoped=true"
import script from "./AlterarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AlterarPedidoDeCompraModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AlterarPedidoDeCompraModal.vue?vue&type=style&index=0&id=45a84ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a84ac0",
  null
  
)

export default component.exports